import { useMutation } from "urql";

import { UpdateCustomerLateChargeFeeDocument } from "../../../graphql/generated.ts";

export function useUpdateCustomerLateChargeFee() {
  return useMutation(UpdateCustomerLateChargeFeeDocument);
}
